import { ImageTrackImg } from "./ImageTrackImg";
import clsx from "clsx";

export function ImageTrackingOverlay() {
  return (
    <>
      <div className="animate-fade-in absolute z-10 w-full h-full bg-[rgba(0,0,0,0.6)] pointer-events-none">
        <div className="w-full relative h-full xz-[999] ">
          <ImageTrackImg className="animate-fade-in max-w-[222px] w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
          {/* <div
            className={clsx(
              "fixed bottom-0 left-0 w-full h-full transition-all duration-500 max-h-[193px] "
            )} */}
          {/* > */}
            {/* <img
              src={BottomBar}
              alt="cba background"
              className="absolute bottom-0 w-full h-full object-fill object-bottom"
            /> */}

            {/* <h2 className="p-[30px] w-full font-cba-sans-bold absolute bottom-0 left-0 xmax-w-[350px] text-left text-2xl tracking-[1px] leading-[28px]">
              Point your <br />device at the <br /> cube to activate it.
            </h2> */}
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
